import axios from 'axios';

export async function checkImageExists(url: string): Promise<boolean> {
    try {
        const response = await axios.head(url);
        const contentType = String(response.headers['content-type'] ?? '');
        return contentType.startsWith('image/');
    } catch (error) {
        return false;
    }
}

